/**
 * Email HTML for the print document. Printed bodies render inline (in a
 * shadow root) rather than in an iframe: Chrome will not start an iframe
 * part-way down a page, so every tall message would push to a fresh page
 * and leave the previous one mostly blank.
 *
 * Inline means our origin, so the HTML goes through DOMPurify (scripts,
 * event handlers, javascript: URLs removed) and form controls, frames and
 * external stylesheets are dropped; unresolved cid: images are stripped as
 * on screen.
 */
import DOMPurify from 'dompurify';
import { sanitizeEmailHtml } from './sanitizeEmailHtml';

/** Scoped to the shadow root: email styles cannot reach the page, nor ours the email. */
export const PRINT_EMAIL_BASE_STYLE = `
  :host {
    display: block;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #1e293b;
    overflow-wrap: anywhere;
  }
  img { max-width: 100%; height: auto; }
  table { max-width: 100%; }
  blockquote { margin: 0.5em 0; padding-left: 1em; border-left: 2px solid #ccc; color: #555; }
  pre { white-space: pre-wrap; }
`;

export function purifyEmailHtmlForPrint(html: string): DocumentFragment {
  return DOMPurify.sanitize(sanitizeEmailHtml(html), {
    RETURN_DOM_FRAGMENT: true,
    FORBID_TAGS: ['form', 'input', 'button', 'select', 'textarea', 'iframe', 'frame', 'object', 'embed', 'link', 'meta', 'base'],
  });
}
